import { useMemo } from 'react';
import { UNITE_RADIO_TRANSCRIPTION } from '@rsos/capstone/src/constants/capabilities';
import useHasCapability from '@rsos/hooks/useHasCapability';
import useHasPermission from '@rsos/hooks/useHasPermission';
import { UNITE_RADIO_TRANSCRIPTION_PERMISSION } from '../constants/permissions';

const useHasAccessToRadioTranscription = () => {
  const hasRadioTranscriptionCapability = useHasCapability(
    UNITE_RADIO_TRANSCRIPTION,
  );
  const hasRadioTranscriptionPermission = useHasPermission(
    UNITE_RADIO_TRANSCRIPTION_PERMISSION,
  );
  const hasAccessToRadioTranscription = useMemo(() => {
    return (
      !!hasRadioTranscriptionCapability?.hasCapability &&
      !!hasRadioTranscriptionPermission?.hasPermission
    );
  }, [hasRadioTranscriptionCapability, hasRadioTranscriptionPermission]);

  return hasAccessToRadioTranscription;
};

export default useHasAccessToRadioTranscription;
